<template>
    <v-dialog v-model="showBooking" fullscreen transition="slide-y-transition" overlay-color="#000"
        overlay-opacity="0.95" :style="`${isAndroidNative ? 'margin-top: 100px; height: 100vh;' : ''} `">
        <v-card class="dialog-card">
            <!-- Close Button -->
            <!-- <v-btn icon class="close-btn" @click="close" color="white">
                <v-icon size="28" color="red">mdi-close</v-icon>
            </v-btn> -->
            <v-btn variant="tonal" class="mt-10+" @click="close"
                style="position: absolute; top: 12px; right: 12px; z-index: 10; background-color: #222; transition: 0.3s ease;">

                {{ $t('closeButton') }}
            </v-btn>


            <!-- Title -->
            <h2 class="dialog-title" style="text-align: left;">{{ $t('bookingAnalytics.title') }}</h2>

            <!-- Content -->
            <v-container class="dialog-content">
                <v-row>
                    <v-col cols="12">
                        <h3 class="section-heading">{{ $t('bookingAnalytics.heading') }}</h3>
                        <ul class="booking-list">
                            <li>{{ $t('bookingAnalytics.list.item1') }}</li>
                            <li>{{ $t('bookingAnalytics.list.item2') }}</li>
                            <li>{{ $t('bookingAnalytics.list.item3') }}</li>
                            <li>{{ $t('bookingAnalytics.list.item4') }}</li>
                            <li>{{ $t('bookingAnalytics.list.item5') }}</li>
                        </ul>
                    </v-col>

                    <v-col cols="12" md="6">
                        <apexchart type="donut" height="250" :options="donutOptions" :series="donutSeries" />
                    </v-col>

                    <v-col cols="12" md="6">
                        <apexchart type="bar" height="250" :options="barOptions" :series="barSeries" />
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>



<script setup>
import { ref, onMounted, onBeforeUnmount, defineExpose } from 'vue';
import { Capacitor } from '@capacitor/core';

const isAndroidNative = Capacitor.getPlatform() === 'android' && Capacitor.isNativePlatform();

const showBooking = ref(false);
function open() { showBooking.value = true; }
function close() { showBooking.value = false; }
defineExpose({ open });

const donutOptions = {
    chart: { type: 'donut' },
    labels: ['Meeting Rooms', 'Team Zones', 'Private Desks', 'Other'],
    legend: { position: 'bottom', labels: { colors: '#ccc' } },
    dataLabels: { enabled: true },
    colors: ['#00bcd4', '#ff9800', '#4caf50', '#9c27b0'],
    theme: { mode: 'dark' }
};
const donutSeries = ref([44, 25, 18, 13]);

const barOptions = {
    chart: { type: 'bar' },
    xaxis: {
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        labels: { style: { colors: '#ccc' } }
    },
    plotOptions: { bar: { horizontal: false, columnWidth: '55%' } },
    dataLabels: { enabled: false },
    colors: ['#03a9f4'],
    theme: { mode: 'dark' }
};
const barSeries = ref([{ name: 'Bookings', data: [30, 45, 32, 60, 25] }]);

const handleResize = () => {
    donutSeries.value = [44, 25, 18, 13];
    barSeries.value = [{ name: 'Bookings', data: [30, 45, 32, 60, 25] }];
};

onMounted(() => window.addEventListener('resize', handleResize));
onBeforeUnmount(() => window.removeEventListener('resize', handleResize));
</script>


<style scoped>
.dialog-card {
    background-color: #111;
    color: #fff;
    min-height: 100vh;
    padding: 2rem 1rem;
    overflow-y: auto;
    position: relative;
}

.close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 10;
    background-color: #222;
    border-radius: 50%;
    transition: 0.3s ease;
}

.close-btn:hover {
    background-color: #333;
}

.dialog-title {
    text-align: center;
    font-size: 1.8rem;
    font-weight: bold;
    margin-top: 1rem;
    margin-bottom: 2rem;
}

.dialog-content {
    max-width: 1000px;
    margin: 0 auto;
}

.section-heading {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 0.75rem;
    color: #00bfff;
}

.booking-list {
    padding-left: 1.25rem;
    margin-bottom: 2rem;
}

.booking-list li {
    margin-bottom: 0.5rem;
    font-size: 0.96rem;
    line-height: 1.5;
    color: #ccc;
}
</style>
